<template>
  <div class="old-staff">
    <h3>
      <Icon @click="handleGoBack" type="ios-arrow-dropleft-circle"/>
      减员数据统计
    </h3>
    <Dashboard :dashboardData="dashboardData"></Dashboard>
    <div class="staff-list">
      <div class="filter-form">
        <div class="left">
          员工姓名：<i-input v-model="filterData.employeeName" style="width: 100px" ></i-input>
          原属部门：
          <Select style="width: 150px" v-model="filterData.departmentId">
            <Option v-for="item in departmentList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
          <Button @click="handleSearch" type="primary" style="margin-left: 15px">查询</Button>
          <Button @click="handleClearForm" style="margin-left: 5px">重置</Button>
        </div>
      </div>
      <div class="table-data">
        <Table :columns="staffColumn" :data="staffList"></Table>
        <div class="page">
          <Page :total="total" :current="filterData.page" :page-size="filterData.rows" @on-change="pageChange"></Page>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/jsx">
  import Dashboard from '@/view/common/Dashboard.vue';
  import { Dropdown, Icon, DropdownMenu } from 'iview';
  import DisplayStaff from './DisplayStaff.vue';
  export default {
    name: 'OldStaff',
    components: {
      Dashboard
    },
    data () {
      return {
        dashboardData: {
          employeeNum: { label: '减员离职员工数', value: null }, // 在职员工数
          maleEmployeeNum: { label: '男性员工', value: null }, // 男性员工
          womenEmployeeNum: { label: '女性员工', value: null }, // 女性员工
          deptNum: { label: '涉及部门', value: null } // 部门数量
        },
        filterData: {
          employeeName: null,
          departmentId: null,
          status: 0, // 离职
          page: 1,
          rows: 10
        },
        total: null,
        departmentList: [],
        staffColumn: [
          {
            title: '姓名',
            render: (h, params) => {
              return (
                <div>
                <span></span>
                <span>{params.row.name}</span>
              </div>
              )
            },
            align: 'center'
          },
          {
            title: '性别',
            render: (h, params) => {
              return (
                <div>
                <span>{{ 1: '男', 2: '女' }[params.row.sex]}</span>
              </div>
              )
            },
            align: 'center'
          },
          {
            title: '原部门',
            key: 'departmentName',
            align: 'center'
          },
          {
            title: '手机号',
            key: 'mobile',
            align: 'center'
          },
          {
            title: 'E卡信息',
            key: 'cardNo',
            align: 'center'
          },
          {
            title: '操作',
            render: (h, params) => {
              return (
                <Dropdown transfer={true}>
                  操作<Icon type="ios-arrow-down"/>
                  <DropdownMenu slot="list">
                    <DisplayStaff userId={params.row.id} >
                      <li>查看</li>
                    </DisplayStaff>
                    <li onClick={() => this.reEntry(params.row.id)}>重新入职</li>
                  </DropdownMenu>
                </Dropdown>
              )
            }
          }
        ],
        staffList: []
      }
    },
    mounted () {
      this.initialData();
    },
    methods: {
      initialData () {
        this.fetchDashboard();
        this.fetchDepartment();
        this.updateStaff();
      },
      fetchDashboard () {
        this.$get(`/company/employee/info`, { status: 0 }).then(res => {
          if (res.success) {
            for (let item in this.dashboardData) {
              this.dashboardData[item].value = res.data[item]
            }
          }
        });
      },
      fetchDepartment () {
        this.$get(`/department`).then(res => {
          if (res.success) {
            this.departmentList = res.data;
          }
        })
      },
      updateStaff () {
        this.$post(`/company/employee/list`, this.filterData).then(res => {
          if (res.success) {
            this.staffList = res.data.list;
            this.filterData.page = res.data.pageNum;
            this.total = res.data.total;
          }
        })
      },
      handleClearForm () {
        this.filterData.employeeName = null;
        this.filterData.departmentId = null;
        this.filterData.orderByParam = null;
        this.filterData.page = 1;
        this.updateStaff();
      },
      handleSearch () {
        this.filterData.page = 1;
        this.updateStaff();
      },
      handleSort (e) {
        this.filterData.orderByParam = e;
        this.filterData.page = 1;
        this.updateStaff();
      },
      pageChange (e) {
        this.filterData.page = e;
        this.updateStaff();
      },
      handleGoBack () {
        this.$router.go(-1)
      },
      reEntry (id) {
        let that = this;
        this.$Modal.confirm({
          title: '员工重新入职',
          content: '确认要激活员工吗?',
          onOk () {
            this.$get(`/activation/user`, { id }).then((res) => {
              if (res.success) {
                that.$Message.success(res.msg);
                that.initialData();
                that.$emit('change');
              }
            })
          }
        })
      }
    }
  }
</script>

<style lang="less">
  .old-staff{
    /*flex: 4;*/
    width: 80%;
    padding: 20px;
    h3{
      font-size: 16px;
      line-height: 2;
      i {
        cursor: pointer;
      }
    }
    .staff-list{
      padding: 20px;
      .filter-form{
        display: flex;
        justify-content: space-between;
        .right{

        }
      }
      .table-data{
        padding-top: 10px;
        .ivu-dropdown-menu{
          li{
            text-align: center;
            padding: 5px;
            cursor: pointer;
            &:hover{
              background: #f3f3f3;
            }
          }
        }
      }
      .page{
        margin-top: 50px;
        .ivu-page{
          text-align: center;
        }
      }
    }
  }
</style>
